import styled, { css } from 'styled-components';
import { Icon } from 'src/components';

export const Container = styled.div<{ $type: string }>(
  ({ theme, $type }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: ${theme.sz.s1};
    padding: ${theme.sz.s4};
    width: 100%;
    border-radius: ${theme.bo.mediumSmall};
    background-color: ${
      $type === 'learned'
        ? theme.co.success98
        : $type === 'heard'
          ? theme.co.error98
          : theme.co.information98
    };
  `,
);

export const IconContainer = styled.div(
  () => css`
    display: flex;
    align-items: center;
    justify-content: center;
  `,
);

export const StyledIcon = styled(Icon)<{ $type: string }>(
  ({ theme, $type }) => css`
    color: ${
      $type === 'learned'
        ? theme.co.success40
        : $type === 'heard'
          ? theme.co.error60
          : theme.co.information50
    };
    font-size: ${theme.sz.s6};
  `,
);

export const Content = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    color: ${theme.co.secondary20};
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxs};
    color: ${theme.co.secondary20};
    @media (max-width: ${theme.sz.maxMobileBreakpoint}) {
      word-break: break-word;
    }
  `,
);

export const Count = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.m};
    color: ${theme.co.secondary20};
  `,
);

export const LoaderContainer = styled.div(
  ({ theme }) => css`
    width: ${theme.sz.s6};
  `,
);
